import React, { useState, useEffect } from "react";

import PanelTemplate from "../../templates/Panel";
import Input from "../../components/Input";
import api from "../../services/api";
import { useNavigate, useParams } from "react-router-dom";
import Box from "../../components/Box";
import PageFooter from "../../components/PageFooter";
import Button from "../../components/Button";
import { renderError } from "../../helpers/errors";
import InputEditor from "../../components/InputEditor";
import { Loading } from "../../components/Loading";
import InputTextarea from "../../components/InputTextarea";
import { toast } from "react-toastify";
import { ModalDelete } from "../../components/ModalDelete";

export const PageEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(null);

    const [title, setTitle] = useState('');
    const [text, setText] = useState('');
    const [slug, setSlug] = useState('');
    const [metaTitle, setMetaTitle] = useState('');
    const [metaDescription, setMetaDescription] = useState('');

    const [showDelete, setShowDelete] = useState(false);
    const [deleting, setDeleting] = useState(false);

    useEffect(() => {
        getPage();
    }, []);

    const getPage = () => {
        setLoading(true);

        api.get(`/page/${id}`).then(res => {
            let resource = res.data.resource;

            setPage(resource);
            setTitle(resource.title);
            setText(resource.text);
            setSlug(resource.slug);
            setMetaTitle(resource.meta_title);
            setMetaDescription(resource.meta_description);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    }

    const updatePage = () => {
        setLoading(true);

        api.put(`/page/${id}`, {
            title,
            text,
            slug,
            meta_title: metaTitle,
            meta_description: metaDescription
        }).then(res => {
            getPage();
            toast.success('Página atualizada com sucesso');
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const deletePage = () => {
        setDeleting(true);

        api.delete(`/page/${id}`).then(() => {
            toast.success('Página excluída com sucesso');
            navigate('/page/list');
        }).catch(error => {
            renderError(error);
            setDeleting(false);
            setShowDelete(false);
        });
    }

    const isDefault = page?.is_default === true;

    return (
        <>
            <ModalDelete
                show={showDelete}
                action={deletePage}
                loading={deleting}
                close={() => setShowDelete(false)}
                text={<p>Tem certeza que deseja excluir a página <strong>{page?.title}</strong>?</p>}
            />
            <PanelTemplate id="page-edit">
                <Box>
                    {!loading &&
                        <>
                            <Input label={`Título`} value={title} change={setTitle} />
                            <Input
                                label={`Slug`}
                                value={slug}
                                change={setSlug}
                                mask={`convertToSlug`}
                                disabled={isDefault}
                            />
                            {isDefault &&
                                <p className="input-hint">Essa é uma página padrão do sistema — o slug não pode ser alterado.</p>
                            }
                            <Input label={`Meta title`} value={metaTitle} change={setMetaTitle} />
                            <InputTextarea label={`Meta description`} value={metaDescription} change={setMetaDescription} rows={4} />
                            <h2 className="section-title">Conteúdo da página</h2>
                            <InputEditor value={text} change={setText} />
                        </>
                    }
                    {loading &&
                        <Loading />
                    }
                </Box>
                <PageFooter>
                    {!isDefault &&
                        <Button
                            type={`secondary`}
                            size={`small`}
                            svg={`delete`}
                            text={`Excluir página`}
                            action={() => setShowDelete(true)}
                            loading={loading}
                        />
                    }
                    <Button
                        type={`primary`}
                        size={`small`}
                        svg={`save-white`}
                        text={`Salvar alterações`}
                        action={updatePage}
                        loading={loading}
                    />
                </PageFooter>
            </PanelTemplate>
        </>
    );
}

export default PageEdit;
